import { ClipboardCheckIconStatic } from "./ClipboardCheckIconStatic";

interface ClipboardCheckIconAnimatedProps {
  width?: number;
  height?: number;
  className?: string;
  duration?: number;
  easing?: string;
  color?: string;
  hoverColor?: string;
  strokeWidth?: number;
}

export const ClipboardCheckIconAnimated = ({
  width = 24,
  height = 24,
  className,
  duration = 0.6,
  easing = "ease-in-out",
  color = "currentColor",
  hoverColor = color,
  strokeWidth = 2
}: ClipboardCheckIconAnimatedProps) => {
  const svgEasing = easing === "ease-in-out" ? "ease" : easing;

  const animationAttributes = {
    dur: `${duration * 2}s`,
    begin: "clipboardParentGroup.mouseover",
    end: "clipboardParentGroup.mouseout",
    repeatCount: "indefinite",
    calcMode: "spline",
    keySplines: "0.42 0 0.58 1; 0.42 0 0.58 1",
    keyTimes: "0; 0.5; 1",
    restart: "whenNotActive"
  } as const;

  const dashLength = 20; // checkmark draw length

  return (
    <div className="group">
      <div className={`group-hover:hidden ${className}`} style={{ width, height }}>
        <ClipboardCheckIconStatic
          width={width}
          height={height}
          color={color}
          strokeWidth={strokeWidth}
        />
      </div>

      <div className={`hidden group-hover:block ${className}`} style={{ width, height }}>
        <svg
          width={width}
          height={height}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="clipboardParentGroup">
            <rect width="24" height="24" fill="none">
              <animateTransform
                attributeName="transform"
                type="translate"
                values="0 0; 0 0.5; 0 0"
                {...animationAttributes}
              />
              <animateTransform
                attributeName="transform"
                type="rotate"
                additive="sum"
                values="0 12 12; 0.3 12 12; 0 12 12"
                {...animationAttributes}
              />
            </rect>

            <rect width="8" height="4" x="8" y="2" rx="1" ry="1" stroke={color} strokeWidth={strokeWidth}>
              <animate
                attributeName="stroke"
                values={`${color}; ${hoverColor}; ${color}`}
                {...animationAttributes}
              />
            </rect>

            <path
              d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
              stroke={color}
              strokeWidth={strokeWidth}
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <animate
                attributeName="stroke"
                values={`${color}; ${hoverColor}; ${color}`}
                {...animationAttributes}
              />
            </path>

            <path
              d="m9 14 2 2 4-4"
              stroke={color}
              strokeWidth={strokeWidth}
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeDasharray={dashLength}
              strokeDashoffset={dashLength}
            >
              <animate
                attributeName="stroke-dashoffset"
                values={`${dashLength}; 0; ${dashLength}`}
                {...animationAttributes}
              />
              <animate
                attributeName="stroke"
                values={`${color}; ${hoverColor}; ${color}`}
                {...animationAttributes}
              />
            </path>

            <rect width="24" height="24" fill="transparent" style={{ cursor: "pointer" }} />
          </g>
        </svg>
      </div>
    </div>
  );
};
